import styled from 'styled-components';
import { gray2 } from '@styles/styled/variables';

export const PolicyWrapper = styled.div`
  margin: 0;
  margin-top: 4px;
  padding: 8px 0 0;
  background: white;
  overflow-x: scroll;
  white-space: nowrap;

  :hover {
    cursor: ${(props) => (props.sortable ? 'grab' : 'default')};
    box-shadow: ${(props) => (props.sortable ? '0px 0px 3px 3px rgba(200,200,200,0.5)' : '')};
  }

  &.ghost-version {
    background: ${gray2};
  }
`;
